<template lang="pug">
  .component-selectize-plan
    //pre {{items}}
    loading-spinner(v-if = "loading")
    selectize(v-if="options", :value="value" :options="options", value-field="id", :maxItems="maxItems" label-field="name", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :renderTemplate="renderTemplate", @itemAdded="optionSelected", @itemRemoved="optionRemoved",  placeholder="Plan", :allowEmptyOption="allowEmptyOption", :selectedValue="selectedValue")
</template>

<script>
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
  import BaseSelectize from './BaseSelectize'
  import Selectize from '../../../Selectize'
  import LoadingSpinner from '../../../LoadingSpinner'

  export default {
    name: 'SelectizePlan',
    extends: BaseSelectize,
    components: {Selectize, LoadingSpinner},
    data() {
      return {
        loading: true,
        searchableFields: [
          'id',
          'name',
        ],
      }
    },
    created() {
      KeplerBackofficeSdk.selects.plans(this.disabled, (data) => {
        this.options = data
        this.loading = false
      })
    },
    methods: {
      optionTemplate(item, escape) {
        if (item.id) {
          return `<div><div><small>PL${item.id}</small></div><div>${item.name}</div></div>`
        }
        return `<div><div>Select plan</div></div>`
      },
      renderTemplate(item, escape) {
        if (item.id) {
          return `<div>PL${item.id} ${item.name}</div>`
        }
        return `<div><div>Select plan</div></div>`
      },
      optionsLoader() {

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizePlan.vue?2245b450